import script from "./WReportRecommendations.vue?vue&type=script&lang=ts&setup=true"
export * from "./WReportRecommendations.vue?vue&type=script&lang=ts&setup=true"

import "./WReportRecommendations.vue?vue&type=style&index=0&id=144c3b33&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-144c3b33"]])

export default __exports__